import { FormikProps } from 'formik';

import { Grid } from '@mui/material';
import { LocalTabContent, CommonButtonWrapper } from '@styles/CommonStyles';
import { FormPart } from '@modules/shared/components/FormPart';
import { statesList } from '@shared/constants/statesList';
import { PhoneInputField } from '@shared/fields/PhoneInputField';
import { SelectAutocompleteField } from '@shared/fields/SelectAutocompleteField';
import { TextInputField } from '@shared/fields/TextInputField';
import { ZipCodeInputField } from '@shared/fields/ZipCodeInputField';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { IAddress } from '../interfaces';

const formConfig = [
  {
    width: '50%',
    name: 'name',
    label: 'Name',
    component: TextInputField,
  },
  {
    width: '50%',
    name: 'nickName',
    label: 'Nickname',
    component: TextInputField,
  },
  {
    width: '50%',
    name: 'company',
    label: 'Company',
    component: TextInputField,
  },
  {
    width: '50%',
    name: 'address',
    label: 'Address',
    component: TextInputField,
  },
  {
    width: '50%',
    name: 'address2',
    label: 'Address 2',
    component: TextInputField,
  },
  {
    width: '50%',
    name: 'city',
    label: 'City',
    component: TextInputField,
  },
  {
    width: '20%',
    name: 'state',
    label: 'State',
    options: statesList,
    component: SelectAutocompleteField,
  },
  {
    width: '40%',
    name: 'zip.code',
    label: 'Zip',
    component: ZipCodeInputField,
  },
  {
    width: '40%',
    name: 'phoneNumber',
    label: 'Phone Number',
    component: PhoneInputField,
  },
];


interface IAddressProps extends Partial<FormikProps<IAddress>> {
  handleClose: () => void;
}

export const AddressForm = ({ handleClose }: IAddressProps) => (
  <>
    <LocalTabContent style={{ height: 'auto' }}>
      <Grid container spacing={12}>
        <Grid item md={12}>
          <FormPart config={formConfig} />
        </Grid>
      </Grid>
    </LocalTabContent>

    <CommonButtonWrapper>
      <CancelButton onClick={handleClose} />
      <SaveButton/>
    </CommonButtonWrapper>
  </>
);
